export const CONNECTING = 0 //The connection is not yet open.
export const OPEN =	1 //The connection is open and ready to communicate.
export const CLOSING = 2 //The connection is in the process of closing.
export const CLOSED = 3 //The connection is closed or couldn't be opened.